import {
  SET_PODIO_LOADING,
  SET_PODIO_ERROR,
  FETCH_PODIO_ACCOUNTS_SUCCESS,
  FETCH_PODIO_ACCESS_TOKEN_SUCCESS,
  FETCH_PODIO_ORGS_SUCCESS,
  FETCH_PODIO_SPACES_SUCCESS,
  FETCH_PODIO_APPS_SUCCESS,
  SET_SELECTED_PODIO_ACCOUNT,
  SET_SELECTED_PODIO_ORG,
  SET_SELECTED_PODIO_SPACE,
  SET_SELECTED_PODIO_APP,
  CLEAR_PODIO_FROM_ORG,
  CLEAR_PODIO_FROM_SPACE,
  CLEAR_PODIO_FROM_ACCOUNT,
} from '../Actions/AI/type';

const initialState = {
  loading: false,
  error: null,

  // data caches
  accounts: [],                               // list from API 1
  accessTokenByAccount: {},                   // { [accountId]: { token, expiresAt:number } }
  orgsByAccount: {},                          // { [accountId]: Org[] }
  spacesByOrg: {},                            // { [orgId]: Space[] }
  appsBySpace: {},                            // { [spaceId]: App[] }

  // selections
  selected: {
    accountId: null,
    orgId: null,
    spaceId: null,
    appId: null,
  },
};

const podioLookup = (state = initialState, action) => {
  switch (action.type) {
    case SET_PODIO_LOADING:
      return { ...state, loading: true, error: null };

    case SET_PODIO_ERROR:
      return { ...state, loading: false, error: action.payload };

    case FETCH_PODIO_ACCOUNTS_SUCCESS:
      return { ...state, loading: false, accounts: action.payload || [], error: null };

    case FETCH_PODIO_ACCESS_TOKEN_SUCCESS: {
      const { accountId, token, expiresAt } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        accessTokenByAccount: {
          ...state.accessTokenByAccount,
          [accountId]: { token, expiresAt },
        },
      };
    }

    case FETCH_PODIO_ORGS_SUCCESS: {
      const { accountId, orgs } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        orgsByAccount: { ...state.orgsByAccount, [accountId]: orgs || [] },
      };
    }

    case FETCH_PODIO_SPACES_SUCCESS: {
      const { orgId, spaces } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        spacesByOrg: { ...state.spacesByOrg, [orgId]: spaces || [] },
      };
    }

    case FETCH_PODIO_APPS_SUCCESS: {
      const { spaceId, apps } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        appsBySpace: { ...state.appsBySpace, [spaceId]: apps || [] },
      };
    }

    case SET_SELECTED_PODIO_ACCOUNT:
      return {
        ...state,
        selected: { accountId: action.payload, orgId: null, spaceId: null, appId: null },
      };

    case SET_SELECTED_PODIO_ORG:
      return {
        ...state,
        selected: { ...state.selected, orgId: action.payload, spaceId: null, appId: null },
      };

    case SET_SELECTED_PODIO_SPACE:
      return {
        ...state,
        selected: { ...state.selected, spaceId: action.payload, appId: null },
      };

    case SET_SELECTED_PODIO_APP:
      return {
        ...state,
        selected: { ...state.selected, appId: action.payload },
      };

    case CLEAR_PODIO_FROM_ACCOUNT: {
      return {
        ...state,
        orgsByAccount: {},
        spacesByOrg: {},
        appsBySpace: {},
        selected: { accountId: null, orgId: null, spaceId: null, appId: null },
      };
    }

    case CLEAR_PODIO_FROM_ORG: {
      const { selected } = state;
      return {
        ...state,
        spacesByOrg: {},
        appsBySpace: {},
        selected: { ...selected, orgId: null, spaceId: null, appId: null },
      };
    }

    case CLEAR_PODIO_FROM_SPACE: {
      const { selected } = state;
      return {
        ...state,
        appsBySpace: {},
        selected: { ...selected, spaceId: null, appId: null },
      };
    }

    default:
      return state;
  }
};

export default podioLookup;
